import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api } from "@/lib/api";

const DataContext = createContext(null);
const EMPTY = { companies: [], branches: [], parties: [], teams: [], employees: [], projects: [], price_lists: [], outcome_codes: [], integration_sources: [], visible_company_ids: [] };

export function DataProvider({ children }) {
  const [lookups, setLookups] = useState(EMPTY);
  const [companyId, setCompanyIdState] = useState(() => localStorage.getItem("elysium.company") || "");

  const reload = useCallback(async () => {
    const { data } = await api.get("/lookups");
    setLookups(data);
  }, []);

  useEffect(() => {
    reload().catch(() => {});
  }, [reload]);

  const setCompanyId = (id) => {
    localStorage.setItem("elysium.company", id);
    setCompanyIdState(id);
  };

  const maps = useMemo(() => {
    const m = {};
    Object.entries(lookups).forEach(([k, list]) => {
      if (Array.isArray(list) && list[0]?.id) m[k] = Object.fromEntries(list.map((x) => [x.id, x]));
      else m[k] = {};
    });
    return m;
  }, [lookups]);

  const nameOf = (kind, id, field = "name") => {
    const x = id && maps[kind]?.[id];
    if (!x) return "—";
    return x[field] || x.legal_name || x.name || "—";
  };
  const companies = lookups.companies.filter((c) => c.active !== false);
  const visibleCompanies = companies.filter((c) => lookups.visible_company_ids.includes(c.id));
  const validCompanyId = visibleCompanies.some((c) => c.id === companyId) ? companyId : "";
  const inCompany = (cid) => !validCompanyId || cid === validCompanyId;

  return (
    <DataContext.Provider value={{ ...lookups, companies, visibleCompanies, maps, nameOf, reload, companyId: validCompanyId, setCompanyId, inCompany }}>
      {children}
    </DataContext.Provider>
  );
}

export const useData = () => useContext(DataContext);
